
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#8d98aa","stroke-linecap":"round","stroke-linejoin":"round","data-name":"vuesax/twotone/ticket-star"}},[_c('path',{attrs:{"d":"M12.747 3h-7.5c-2.873 0-3.675.69-3.743 3.375A2.621 2.621 0 014.122 9a2.626 2.626 0 01-2.618 2.625C1.572 14.31 2.374 15 5.246 15h7.5c3 0 3.75-.75 3.75-3.75v-4.5c.001-3-.749-3.75-3.749-3.75z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M6.745 3v2.625M6.745 12.375V15M11.268 6.997l.465.937a.322.322 0 00.233.173l1.035.15a.312.312 0 01.172.533l-.75.727a.31.31 0 00-.09.278l.18 1.028a.311.311 0 01-.45.33l-.923-.487a.334.334 0 00-.292 0l-.92.486a.31.31 0 01-.452-.329l.18-1.027a.317.317 0 00-.09-.278l-.738-.728A.312.312 0 019 8.257l1.028-.15a.293.293 0 00.232-.173l.461-.937a.3.3 0 01.547 0z","opacity":".4"}})])])
          )
        }
      }
    